import { MdEmail } from 'react-icons/md';
import { FaWhatsapp, FaFacebookF, FaLinkedinIn, FaTwitter } from 'react-icons/fa';
import { BsThreads } from 'react-icons/bs';

export const SOCIAL_LINKS = [
  {
    name: 'Whatsapp',
    icon: FaWhatsapp,
    getUrl: (link: string) => `https://wa.me/?text=${encodeURIComponent(link)}`,
    color: '#25D366',
  },
  {
    name: 'Facebook',
    icon: FaFacebookF,
    getUrl: (link: string) => `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(link)}`,
    color: '#1877F2',
  },
  {
    name: 'Linkedin',
    icon: FaLinkedinIn,
    getUrl: (link: string) => `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(link)}`,
    color: '#0A66C2',
  },
  {
    name: 'Twitter',
    icon: FaTwitter,
    getUrl: (link: string) => `https://twitter.com/intent/tweet?url=${encodeURIComponent(link)}`,
    color: '#1DA1F2',
  },
  {
    name: 'Threads',
    icon: BsThreads,
    getUrl: (link: string) => `https://www.threads.net/intent/post?text=${encodeURIComponent(link)}`,
    color: '#000000',
  },
  {
    name: 'Email',
    icon: MdEmail,
    getUrl: (link: string) => `mailto:?subject=Join my meeting&body=${encodeURIComponent(link)}`,
    color: '#4A6CF7',
  },
];
